export default {"src":"/_next/static/media/apple_logo.518e7be3.svg","height":118,"width":100};